import { Link } from 'react-router-dom';

// Globálny footer (odkazy) — na rozdiel od footer.attribution na CompanyPage
// (zdroje dát pre konkrétnu firmu), toto je navigačný footer na každej stránke.
export function SiteFooter() {
  return (
    <footer
      style={{
        marginTop: '3rem',
        padding: '1.5rem 1.5rem 5rem',
        borderTop: '2px solid var(--chrome-gold)',
        background: 'var(--chrome-bg)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.4rem 1.2rem',
        justifyContent: 'center',
        fontSize: '0.82rem',
        color: 'var(--chrome-muted)',
      }}
    >
      <span style={{ fontWeight: 700, color: 'var(--chrome-ink)' }}>
        © {new Date().getFullYear()} corpuls{' '}
        <span style={{ color: 'var(--chrome-gold)', letterSpacing: '0.2em', fontSize: '0.7rem' }}>
          ANALYTIKA
        </span>
      </span>
      <Link to="/cennik" className="footer-link">
        Cenník
      </Link>
      <Link to="/podmienky" className="footer-link">
        Podmienky používania
      </Link>
      <Link to="/metodika" className="footer-link">
        Ako čítať dáta
      </Link>
      <Link to="/ochrana-udajov" className="footer-link">
        Ochrana údajov
      </Link>
      <Link to="/nastroje" className="footer-link">
        Nástroje
      </Link>
      <Link to="/dokumentacia-api" className="footer-link">
        API
      </Link>
      <a href="mailto:info@marstein.sk" className="footer-link">
        info@marstein.sk
      </a>
    </footer>
  );
}
